// extracted by mini-css-extract-plugin
export default {"Products":"Products_Products__hBHc1","products_list":"Products_products_list__eWg1Y"};